import { Button, Card, CardContent, CardHeader, FormControl, Grid, Input, InputLabel, Paper } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpClient } from "../../../web-services/http-client";
import { IUserData } from "../../../web-services/models/user-data";
import { objectToFormData } from "../../../web-services/utils/object-to-form-data";
import { logIn } from "../../../web-services//auth-service";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function LoginPage(props: { httpClient: HttpClient })
{
    // TODO: get this data from backend.
    const [errorMsg, setErrorMsg] = useState<string>();
    const [isSendingRequest, setIsSendingRequest] = useState<boolean>(false);
    const [username, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [redirect, setRedirect] = useState(false);

    const navigate = useNavigate();

    useEffect(() =>
    {
        if (!isSendingRequest) return;
        const fetchData = async () =>
        {
            // Tabula rasa at the beginning.
            setErrorMsg(undefined);

            try
            {
                let data = (await props.httpClient.post<IUserData[]>(
                    "user/login", "",
                    objectToFormData({
                        username: username,
                        password: password
                    }), 15000)).data;


                if (data.token)
                {
                    localStorage.setItem("user", JSON.stringify(data));
                }
                setRedirect(true);
            }
            catch (err: any)
            {
                console.log(err);

                // Check for generic error message in case of backend being down for example.
                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorMsg("Kérjük, próbálja újra az adatlekérést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }

            setIsSendingRequest(false);
        };

        fetchData().catch(console.error);


        if (redirect)
        {
            navigate("/", { state: { reloadNeeded: true } });
            window.location.reload();
        }
    }, [isSendingRequest, redirect]);

    const fetchLogin = () =>
    {
        try
        {
            logIn(props.httpClient, username, password);
            setIsSendingRequest(false);
            setRedirect(true);
        }
        catch (err: any)
        {
            setErrorMsg("Hibás felhasználó és vagy jelszó!");
        }
    };
    const handleSaveSuccess = () =>
    {
        setIsSendingRequest(true);
    };


    return (
        <div className="container">
            <Paper className="main-paper">
                <CardHeader title="Kérem jelentkezzen be" />
                <Card>
                    <CardContent>
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12}>
                                <Grid container justifyContent="center">
                                    <FormControl variant="standard">
                                        <InputLabel>Felhasználó</InputLabel>
                                        <Input autoComplete="username"
                                            value={username} onChange={e => setUserName(e.target.value)} required
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justifyContent="center">
                                    <FormControl variant="standard">
                                        <InputLabel>Jelszó</InputLabel>
                                        <Input type="password" autoComplete="current-password"
                                            value={password} onChange={e => setPassword(e.target.value)} required
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} >
                                <Grid container justifyContent="center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<ExitToAppIcon />}
                                        onClick={handleSaveSuccess}
                                    >
                                        Bejelentkezés
                                    </Button>
                                </Grid>
                            </Grid>
                            {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
                        </Grid>
                    </CardContent>
                </Card>
            </Paper>
        </div>
    );
}
